<div class="container py-md-4">

    <div class="row justify-content-center">

        <div class="col-lg-8 col-md-10">

            <ng-container *ngIf="mdl_User.get('strInstallationStatus')?.value">

                <div class="text-center mt-3">

                    <p class="badge rounded-pill alert-primary text-dark px-3 py-2" style="font-size: 12px;">

                        وضعیت درخواست شما :

                        <span class="badge rounded-pill bg-primary text-white px-3 py-2" style="font-size: 12px;">

                            {{ mdl_User.get('strInstallationStatus')?.value }}

                        </span>

                    </p>

                </div>

            </ng-container>

            <div class="accordion" id="accordionPanelsStayOpenExample">

                <!--  اطلاعات زمان بندی نصب تجهیزات  -->

                <ng-container *ngIf="mdl_User.get('tiInstallationStatus')?.value > 1">

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="panelsStayOpen-headingOne">

                            <button [ngClass]="activeAccordion == 1 ? '' : 'collapsed'" class="accordion-button "
                                type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne"
                                [attr.aria-expanded]="isOpen(1)" aria-controls="panelsStayOpen-collapseOne">

                                اطلاعات زمان بندی نصب تجهیزات

                            </button>

                        </h2>

                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse "
                            [class.show]="isOpen(1)" aria-labelledby="panelsStayOpen-headingOne"
                            data-bs-parent="#accordionPanelsStayOpenExample">

                            <div class="accordion-body">

                                <div class="card border-0 rounded-4">

                                    <div class="card-body px-4 px-md-5 pb-5">

                                        <form [formGroup]="mdl_User" class="user-info-form">

                                            <!-- تاریخ ثبت و تاریخ اعلامی برای نصب -->

                                            <div class="row g-3 mb-3">

                                                <div class="col-md-6">

                                                    <label for="strRegisterDateTime" class="form-label fw-semibold">

                                                        تاریخ ثبت

                                                    </label>

                                                    <input type="text"
                                                        class="form-control form-control-lg rounded-3 text-start"
                                                        dir="ltr" id="strRegisterDateTime"
                                                        formControlName="strRegisterDateTime">

                                                </div>

                                                <div class="col-md-6">

                                                    <label for="strAnnouncementTime" class="form-label fw-semibold">

                                                        تاریخ اعلامی برای نصب

                                                    </label>

                                                    <input type="text"
                                                        class="form-control form-control-lg rounded-3 text-start"
                                                        dir="ltr" id="strAnnouncementTime"
                                                        formControlName="strAnnouncementTime">

                                                </div>

                                            </div>

                                            <!-- نام نصاب و موبایل نصاب -->

                                            <div class="row g-3 mb-3">

                                                <div class="col-md-6">

                                                    <label for="strFullName" class="form-label fw-semibold">

                                                        نام نصاب

                                                    </label>

                                                    <input type="text" class="form-control form-control-lg rounded-3"
                                                        id="strFullName" formControlName="strFullName">

                                                </div>

                                                <div class="col-md-6">

                                                    <label for="strMobile1" class="form-label fw-semibold">

                                                        موبایل نصاب

                                                    </label>

                                                    <input type="tel" class="form-control form-control-lg rounded-3"
                                                        id="strMobile1" formControlName="strMobile1">

                                                </div>

                                            </div>

                                            <!-- تاریخ نصب  -->

                                            <div class="row g-3 mb-3">

                                                <div class="col-md-6">

                                                    <label for="strInstallDate" class="form-label fw-semibold">

                                                        تاریخ نصب

                                                    </label>

                                                    <input type="tel"
                                                        class="form-control form-control-lg rounded-3 text-start"
                                                        dir="ltr" id="strInstallDate" formControlName="strInstallDate">

                                                </div>

                                            </div>

                                            <!-- گزارش نصب -->

                                            <div class="mb-4">

                                                <label for="strInstallerComment" class="form-label fw-semibold">

                                                    گزارش نصب

                                                </label>

                                                <textarea class="form-control form-control-lg rounded-3"
                                                    id="strInstallerComment" formControlName="strInstallerComment"
                                                    rows="3"></textarea>

                                            </div>

                                        </form>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </ng-container>

                <!--  اطلاعات کاربری -->

                <div class="accordion-item">

                    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">

                        <button class="accordion-button" [ngClass]="activeAccordion == 2 ? '' : 'collapsed'"
                            type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"
                            [attr.aria-expanded]="isOpen(2)" aria-controls="panelsStayOpen-collapseTwo">

                            اطلاعات کاربری

                        </button>


                    </h2>

                    <div id="panelsStayOpen-collapseTwo" [class.show]="isOpen(2)" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingTwo" data-bs-parent="#accordionPanelsStayOpenExample">

                        <div class="accordion-body">

                            <div class="card border-0 rounded-4">

                                <div class="card-body px-4 px-md-5 pb-5">

                                    <form [formGroup]="mdl_User" class="user-info-form">

                                        <!-- دکمه پرداخت -->
                                        <div *ngIf="mdl_Payment.get('iResult')?.value == 0" class="row g-3 mb-3">

                                            <div class="col-12 alert alert-warning" role="alert">

                                                <p class=""> کاربر گرامی، جهت قرار گیری در نوبت نصب، لازم است هزینه
                                                    تجهیزات را ابتدا پرداخت کنید. </p>

                                                <div class="text-end">

                                                    <button class="btn btn-warning" (click)="openUrl()">

                                                        پرداخت صورتحساب

                                                    </button>

                                                </div>

                                            </div>

                                        </div>
                                        <!-- نام و نام خانوادگی -->
                                        <div class="row g-3 mb-3">

                                            <div class="col-md-6">

                                                <label for="strName" class="form-label fw-semibold">

                                                    نام

                                                </label>

                                                <input type="text" class="form-control form-control-lg rounded-3"
                                                    id="strName" formControlName="strName"
                                                    placeholder="نام خود را وارد کنید">

                                            </div>

                                            <div class="col-md-6">

                                                <label for="strFamily" class="form-label fw-semibold">

                                                    نام خانوادگی

                                                </label>

                                                <input type="text" class="form-control form-control-lg rounded-3"
                                                    id="strFamily" formControlName="strFamily"
                                                    placeholder="نام خانوادگی خود را وارد کنید">

                                            </div>

                                        </div>
                                        <!-- کد ملی مالک شناور و موبایل مالک شناور -->
                                        <div class="row g-3 mb-3">

                                            <div class="col-md-6">

                                                <label for="strID" class="form-label fw-semibold">

                                                    کد ملی مالک شناور

                                                </label>

                                                <input type="text" inputmode="numeric"
                                                    class="form-control form-control-lg rounded-3" id="strID"
                                                    formControlName="strID" placeholder="کد ملی خود را وارد کنید"
                                                    maxlength="10" type="tel"
                                                    oninput="this.value=this.value.replace(/[^0-9]/g,'')">

                                            </div>

                                            <div class="col-md-6">

                                                <label for="strMobile" class="form-label fw-semibold">

                                                    موبایل مالک شناور

                                                </label>

                                                <input type="tel" class="form-control form-control-lg rounded-3"
                                                    id="strMobile" formControlName="strMobile"
                                                    placeholder="09123456789">

                                            </div>

                                        </div>
                                        <!-- استان و شهر/بندر -->
                                        <div class="row g-3 mb-3">

                                            <div class="col-md-6">

                                                <label for="strState" class="form-label fw-semibold">

                                                    استان

                                                </label>

                                                <select class="form-control form-control-lg w-100 mb-3"
                                                    formControlName="strState" (change)="getCity($event.target.value)">

                                                    <option value=""> انتخاب کنید </option>

                                                    <option *ngFor="let s of lst_States" [value]="s.strState"> {{
                                                        s.strStateName
                                                        }}
                                                    </option>

                                                </select>


                                            </div>

                                            <div class="col-md-6">

                                                <label for="strCity" class="form-label fw-semibold">

                                                    شهر/بندر

                                                </label>

                                                <select class="form-control form-control-lg w-100 mb-3"
                                                    formControlName="strCity">

                                                    <option value=""> انتخاب کنید </option>

                                                    <option *ngFor="let s of list_City" [value]="s.strCity">{{
                                                        s.strCityName }}
                                                    </option>

                                                </select>


                                            </div>


                                        </div>
                                        <!-- نوع شناور و توان موتور شناور -->
                                        <div class="row g-3 mb-3">

                                            <div class="col-md-6">

                                                <label for="tiFloatingType" class="form-label fw-semibold">

                                                    نوع شناور

                                                </label>

                                                <select class="form-control form-control-lg w-100 mb-3"
                                                    formControlName="tiFloatingType">

                                                    <option value=""> انتخاب کنید </option>

                                                    <option *ngFor="let f of lst_FloatingType"
                                                        [value]="f.tiFloatingType">

                                                        {{ f.strFloatingType }}

                                                    </option>

                                                </select>


                                            </div>

                                            <div class="col-md-6">

                                                <label for="iPower" class="form-label fw-semibold">

                                                    توان موتور شناور

                                                </label>

                                                <input type="tel" class="form-control form-control-lg rounded-3"
                                                    id="iPower" formControlName="iPower">


                                            </div>

                                            <div class="col-md-6">

                                                <label for="strRegisterDateTime" class="form-label fw-semibold">

                                                    تاریخ ثبت

                                                </label>

                                                <input class="form-control form-control-lg rounded-3 text-start"
                                                    dir="ltr" id="strRegisterDateTime"
                                                    formControlName="strRegisterDateTime">

                                            </div>

                                            <div class="col-md-6">

                                                <label for="strLicenseNo" class="form-label fw-semibold">

                                                    شناسه شناور

                                                </label>

                                                <input class="form-control form-control-lg rounded-3 text-start"
                                                    id="strLicenseNo" formControlName="strLicenseNo">

                                            </div>

                                        </div>
                                        <!-- آدرس محل نصب -->
                                        <div class="mb-4 position-relative">

                                            <label for="strAddress" class="form-label fw-semibold">

                                                آدرس محل نصب

                                            </label>

                                            <input type="text" class="form-control form-control-lg rounded-3"
                                                id="strAddress" formControlName="strAddress"
                                                [placeholder]='addressPlaceHolder'>

                                            <ng-container *ngIf="mdl_User.get('tiInstallationStatus')?.value < 3">

                                                <button class="btn btn-warning rounded" (click)="show_Map()">

                                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                                                </button>

                                                <custom-map *ngIf="openMap"
                                                    [strValue]="mdl_Map.get('strAddress')?.value"
                                                    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"
                                                    [isOpenModal]="true" (mdl_Submit)="submitMap($event)">

                                                </custom-map>

                                            </ng-container>

                                        </div>
                                        <!-- برق 12 یا 24 ولت -->
                                        <div class="mb-4 position-relative">

                                            <div
                                                class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                                <input class="form-check-input m-0" type="checkbox" id="bHas12DC"
                                                    formControlName="bHas12DC">

                                                <label class="form-check-label pointer text-muted me-2" for="bHas12DC">
                                                    {{ 'دارای برق 12 یا 24 ولت' | faNum}} </label>

                                            </div>

                                        </div>
                                        <!-- کد رهگیری پرداخت -->
                                        <div *ngIf="mdl_User.get('iTrackingCode')?.value != 0" class="row g-3 mb-3">
                                            <div class="col-md-6">
                                                <label for="iTrackingCode" class="form-label fw-semibold">
                                                    کد رهگیری پرداخت
                                                </label>
                                                <input class="form-control form-control-lg text-start rounded-3"
                                                    id="iTrackingCode" formControlName="iTrackingCode">
                                            </div>
                                        </div>
                                        <!-- پرداخت اقساطی -->
                                        <div *ngIf="mdl_User.get('bInstallment')?.value" class="mb-4 position-relative">
                                            <div
                                                class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
                                                <input class="form-check-input m-0" type="checkbox" id="bInstallment"
                                                    formControlName="bInstallment">
                                                <label class="form-check-label pointer text-muted me-2" for="bInstallment">
                                                    {{ 'پرداخت اقساطی' | faNum}} </label>
                                            </div>
                                        </div>
                                        <!-- شرایط پرداخت -->
                                        <div *ngIf="mdl_User.get('bInstallment')?.value && mdl_User.get('strPaymentComment')?.value" class="mb-4">
                                            <label for="strPaymentComment" class="form-label fw-semibold">
                                                شرایط پرداخت
                                            </label>
                                            <textarea class="form-control form-control-lg rounded-3" id="strPaymentComment"
                                                formControlName="strPaymentComment" rows="3"
                                                placeholder="شرایط پرداخت خود">
                                            </textarea>
                                        </div>
                                        <!-- توضیحات -->
                                        <div class="mb-4">

                                            <label for="strComment" class="form-label fw-semibold">

                                                توضیحات

                                            </label>

                                            <textarea class="form-control form-control-lg rounded-3" id="strComment"
                                                formControlName="strComment" rows="3"
                                                placeholder="توضیحات خود را وارد کنید"></textarea>

                                        </div>
                                        <!-- دکمه ویرایش -->
                                        <ng-container
                                            *ngIf="[0,1,2].includes(mdl_User.get('tiInstallationStatus')?.value)">

                                            <div class="d-grid gap-2">

                                                <button class="btn bg-primary text-white py-2 rounded-3 shadow-sm"
                                                    (click)="update_Info()">

                                                    ویرایش اطلاعات

                                                </button>

                                                <ng-container *ngIf="mdl_User.get('tiInstallationStatus').value >= 1">

                                                    <button class="btn btn-outline-secondary"
                                                        (click)="shilatInvoice()">فاکتور</button>

                                                </ng-container>

                                            </div>

                                        </ng-container>

                                    </form>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <app-footer></app-footer>

</div>

<ng-template #paymentDialogTemplate let-modal>
    <ng-container>
        <div class="modal-header">
            <h2 class="modal-title">در انتظار پرداخت</h2>
        </div>
        <div class="modal-body" *ngIf="preInvoiceDetail">
            <p>{{preInvoiceDetail.Description}}</p>
            <p class="fw-bold">{{preInvoiceDetail.Title}}</p>
            <div class="table-responsive">
                <table class="app-table">
                    <thead>
                        <tr>
                            <th class="text-center fw-bold">عنوان</th>
                            <th class="text-center fw-bold">توضیحات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of preInvoiceDetail.Items">
                            <td>{{item.Title}}</td>
                            <td>{{item.Description}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="alert alert-warning">{{preInvoiceDetail.InsuranceNote}}</p>
        </div>
        <div class="modal-footer d-flex flex-row justify-content-start">
            <button type="button" class="btn btn-success" (click)="paymentProcess()">پرداخت</button>
        </div>
    </ng-container>
</ng-template>

<ng-template #tankerInvoiceDialogTemplate let-modal>
    <ng-container>
        <div class="modal-header">
            <h2 class="modal-title">فاکتور</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="dismiss('Cross click')"></button>
        </div>

        <ng-container *ngIf="tankerInvoiceData">

            <div id="payment-receipt" class="modal-body">
                <p class="receipt-title fw-bold">{{tankerInvoiceData.Title}}</p>
                <div class="table-responsive">
                    <table class="app-table">
                        <thead>
                            <tr>
                                <th class="text-center fw-bold">عنوان</th>
                                <th class="text-center fw-bold">توضیحات</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tankerInvoiceData.Items">
                                <td>{{item.Title}}</td>
                                <td>{{item.Description}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="alert alert-warning">{{tankerInvoiceData.InsuranceNote}}</p>
            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-primary" (click)="saveShot()"> دانلود فاکتور </button>

            </div>

        </ng-container>

    </ng-container>

</ng-template>